module.exports = __webpack_public_path__ + "media/images/thumbs/biology/q_quiz_monocot_root_1-15c326c7d340680a46a0923961a02320.jpg";